import Badge, {
  type BadgeVariant,
} from "@/v2-backoffice-client/components/badge"
import {
  CHURN_RISK_LABELS,
  type ChurnRiskLevel,
} from "@/v2-backoffice-client/usage/scope/usage.scope.utils"

export type UsageChurnRiskBadgeProps = {
  level: ChurnRiskLevel
  /** Bullet list of triggering observations, shown as the tooltip. */
  reasons?: string[]
  className?: string
}

const CHURN_RISK_VARIANTS: Record<ChurnRiskLevel, BadgeVariant> = {
  high: "critical",
  medium: "warning",
  low: "positive",
  new: "neutral",
  none: "neutral",
}

// Churn-risk level badge shared by the scope summaries (tenant/customer
// Activity tabs) and the teams/customers table columns — one derivation
// (deriveChurnRisk), one presentation. Tinted-pill palette shared with the
// score/trend badges so red always means "act now".
function UsageChurnRiskBadge(props: UsageChurnRiskBadgeProps) {
  const { level, reasons, className } = props
  return (
    <Badge
      className={className}
      variant={CHURN_RISK_VARIANTS[level]}
      tooltip={reasons?.length ? reasons.join("\n") : undefined}
    >
      {CHURN_RISK_LABELS[level]}
    </Badge>
  )
}

export default UsageChurnRiskBadge
